import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CeoDto } from 'src/app/data-transfer/entities/doc-entities/ceo-dto';
import { SigneeDto } from 'src/app/data-transfer/entities/doc-entities/signee-dto';
import { DialogActions } from 'src/app/model/dictionary';

export class PpwrPersonDialogData {
  constructor(
    public title: string,
    public icon: string,
    public showFunction: boolean,
    public person?: CeoDto | SigneeDto
  ) {}

  get isEditMode(): boolean {
    return !!this.person;
  }
}

@Component({
  selector: 'app-ppwr-person-dialog',
  templateUrl: './ppwr-person-dialog.component.html',
  styleUrls: ['./ppwr-person-dialog.component.scss'],
})
export class PpwrPersonDialogComponent {
  form: FormGroup;
  title: string;
  icon: string;
  showFunction: boolean;
  isEditMode = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public dialogData: PpwrPersonDialogData,
    private dialogRef: MatDialogRef<PpwrPersonDialogComponent>,
    private formBuilder: FormBuilder
  ) {
    this.title = dialogData.title;
    this.icon = dialogData.icon;
    this.showFunction = dialogData.showFunction;
    this.isEditMode = dialogData.isEditMode;

    this.form = this.formBuilder.group({
      firstName: [dialogData.person?.firstName ?? '', Validators.required],
      lastName: [dialogData.person?.lastName ?? '', Validators.required],
      email: [dialogData.person?.email ?? '', Validators.email],
      phoneNumber: [dialogData.person?.phoneNumber ?? '',]
    });

    if(this.showFunction) {
      this.form.addControl('function',
        this.formBuilder.control((dialogData.person as SigneeDto)?.function ?? '',Validators.required));
    }
  }

  doAction(): void {
    this.form.markAllAsTouched();
    if (this.form.invalid) {
      return;
    }

    this.dialogRef.close({
      event: DialogActions.CONFIRM,
      data: this.form.value,
    });
  }

  closeDialog(): void {
    this.dialogRef.close({ event: DialogActions.REJECT });
  }
}
